// extracted by mini-css-extract-plugin
export var addToCartButton = "_k6-b";
export var arrowButtonContainer = "_k6-9";
export var arrowButtonIcon = "_k6-a";
export var carouselArrowButton = "_k6-6";
export var carouselElementContainer = "_k6-1";
export var left = "_k6-7";
export var productDisplayCarouselContainer = "_k6-0";
export var productTileContainer = "_k6-2";
export var productTileImage = "_k6-4";
export var productTileImageContainer = "_k6-3";
export var productTileTitle = "_k6-5";
export var right = "_k6-8";
export var sliderOverflow = "_k6-c";